import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { getAction, httpAction } from '@/api/manage';
import workfLow from '@comp/workFlow/workFlow.vue';
import comment from '@comp/comment/comment';
export default {
  name: 'SiteStopModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    workfLow: workfLow,
    comment: comment
  },
  data: function data() {
    return {
      startUser: null,
      addState: false,
      tabsKey: '1',
      title: '停运申请表单',
      tableName: 'om_site_stop',
      form_fields: ['siteId', 'userId', 'stopReason', 'instrument', 'title', 'stopDescribe', 'status', 'remark', 'tenantId'],
      form_fields_time: ['stopTime', 'estimatedTime'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择申请人员'
          }]
        },
        stopReason: {
          rules: [{
            required: true,
            message: '请选择停战原因!'
          }]
        },
        instrument: {
          rules: [{
            required: true,
            message: '请输入仪器型号!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入停运标题！'
          }]
        },
        stopTime: {
          rules: [{
            required: true,
            message: '请选择停运开始时间!'
          }]
        },
        estimatedTime: {
          rules: [{
            required: true,
            message: '请选择预计复运时间!'
          }]
        },
        stopDescribe: {
          rules: [{
            required: true,
            message: '请输入停站描述!'
          }]
        }
      },
      siteName: '',
      userTree: [],
      status: '1'
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    handleCancel: function handleCancel() {
      this.$emit('ok');
      this.close();
    },
    moment: moment,
    add: function add() {
      this.edit(undefined, true);
    },
    edit: function edit(record) {
      var _this = this;

      var addState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.addState = addState;
      this.tabsKey = '1';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {
        this.siteName = this.model.siteName;
        this.assetIds = this.model.assetId ? this.model.assetId : null;
        this.model.productName = this.model.productName ? this.model.productName : null;
        this.startUser = {
          key: this.model.createBy,
          label: this.model.createBy_userName
        }; // this.selectedAsset.push(this.model.productName)
      } // this.loadCompany() //厂商


      this.queryUserTreeList();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
        that.$refs.iwupload.loadUploadFiles();
      });
      console.log('this.model', this.model);
    },
    // 获取运维人员树
    queryUserTreeList: function queryUserTreeList() {
      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format('yyyy-MM-DD HH:mm:ss') : null;
          }); // formData.assetId = that.assetIds == [] ? null : that.assetIds
          // if (typeof that.assetIds == 'object') {
          //   if (that.assetIds.length < 1) {
          //     this.$message.warning('请选择设备')
          //     that.confirmLoading = false
          //     return
          //   }
          // }

          formData.siteId = formData.siteId ? formData.siteId : _this2.currentSiteId; // formData['status'] = that.status

          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          console.log('formData', formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            // httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post';
          } else {
            // httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put';
          }

          httpAction('/om/site/stop', formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};